import types from './types';

const defaultState = {
  isLoading: false,
  requiredCompetencies: null
};

export default (state = defaultState, { type, data, ...action }) => {
  switch (type) {
    case types.GET_REQUIRED_COMPETENCIES:
      return { ...state, isLoading: true };
    case types.GET_REQUIRED_COMPETENCIES_SUCCESS:
      return { ...state, requiredCompetencies: data, isLoading: false };
    case types.GET_REQUIRED_COMPETENCIES_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
